var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"brief-form__tooltip",attrs:{"data-uk-tooltip":`title: ${_vm.title}; pos: top-left`},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_c('img',{attrs:{"data-uk-svg":"","src":require("@/assets/images/tooltip.svg"),"alt":"plik"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }